/**
 * Like button UI state for product cards
 */

import { productLikeForm } from "./product-like-form";

class ProductLikeRender {
    public static LIKED_CLASS = "products-liked";

    public static ICON_LIKED_CLASS = "bi-heart-fill";

    public static ICON_UNLIKED_CLASS = "bi-heart";

    public static getLikedClass(btn: HTMLElement): string {
        return (btn.dataset.likedClass || "").trim() || ProductLikeRender.LIKED_CLASS;
    }

    public static getIconClasses(btn: HTMLElement): { liked: string; unliked: string } {
        return {
            liked: (btn.dataset.iconLiked || "").trim() || ProductLikeRender.ICON_LIKED_CLASS,
            unliked: (btn.dataset.iconUnliked || "").trim() || ProductLikeRender.ICON_UNLIKED_CLASS,
        };
    }

    public static setButtonState(btn: HTMLElement, liked: boolean): void {
        btn.dataset.isLiked = liked ? "true" : "false";
        btn.setAttribute("aria-pressed", liked ? "true" : "false");

        const likedClass = ProductLikeRender.getLikedClass(btn);
        const iconClasses = ProductLikeRender.getIconClasses(btn);

        if (liked) {
            btn.classList.add(likedClass);
        } else {
            btn.classList.remove(likedClass);
        }

        const icon = productLikeForm.getIcon(btn);
        if (icon) {
            icon.classList.toggle(iconClasses.liked, liked);
            icon.classList.toggle(iconClasses.unliked, !liked);
        }
    }
}

export { ProductLikeRender };
